import origin from './origin'

export default function redirectWithReturn(
  target = '/',
  { pathname = '', search = '' } = window.location
) {
  let returnTo = ''
  if (pathname || search) {
    returnTo = new URLSearchParams({
      return_to: `${pathname}${search ? `?${search}` : ''}`,
    }).toString()
  }

  window.location.href = `${origin}${target}${returnTo ? `?${returnTo}` : ''}`
}
